import { gql } from '@apollo/client';

export const MUTATION_SEND_FORGOT_PASSWORD_EMAIL = gql`
  mutation ($emailAddress: EmailAddress!) {
    initiateForgotPassword(emailAddress: $emailAddress, sendEmail: true) {
      emailAddress
      tokenId
    }
  }
`;

export const MUTATION_DEACTIVATE_MEMBER = gql`
  mutation ($memberId: [Int!], $activate: Boolean) {
    AdminMutations {
      deactivateMember(memberId: $memberId, activate: $activate) {
        member {
          id
          identityId
          patronId
          active
          primaryContact
          firstName
          lastName
          emailAddress
          phoneNumber
          company
          supervisor
          membershipType
          role
          dateInvited
          position
        }
      }
    }
  }
`;

export const MUTATION_REMOVE_MEMBER = gql`
  mutation ($memberId: Int!, $organizationId: Int!) {
    AdminMutations {
      removeMember(memberId: $memberId, organizationId: $organizationId) {
        message
      }
    }
  }
`;
